import { render, staticRenderFns } from "./Officialwebsite.vue?vue&type=template&id=634589b7&scoped=true&"
import script from "./Officialwebsite.vue?vue&type=script&lang=js&"
export * from "./Officialwebsite.vue?vue&type=script&lang=js&"
import style0 from "./Officialwebsite.vue?vue&type=style&index=0&id=634589b7&prod&lang=scss&scoped=true&"
import style1 from "./Officialwebsite.vue?vue&type=style&index=1&id=634589b7&prod&lang=scss&"
import style2 from "./Officialwebsite.vue?vue&type=style&index=2&id=634589b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634589b7",
  null
  
)

export default component.exports